/**
 * Shared JSON:API includes for loading a TAS application
 * with all data needed by the reimagined wizard.
 */
export const REIMAGINED_TAS_APPLICATION_INCLUDES = [
  'tas-courses',
  'tas-courses.tas-assets.attachments',
  'tas-program-instance',
  'tas-program-instance.tas-program-template',
  'tas-program-instance.tas-program-template.conditions.public-assets',
  'tas-program-instance.tas-program-template.tas-field-options',
  'tas-program-instance.employee.person',
  'tas-program-instance.employee.tas-participant',
  'tas-assets.attachments',
];
